import {GeneralService} from './GeneralService';
import config from '../config/config';
import {Contract} from '@ethersproject/contracts';
import {BaseProvider, Web3Provider} from '@ethersproject/providers';
import {formatEther, parseEther} from '@ethersproject/units';
import {TokenService} from './TokenService';

export enum StakingType {
    FIRST = "FIRST",
    SECOND = "SECOND",
}

export function LiquidityMiningService(provider: BaseProvider, stakingType: StakingType) {
    const liquidityStakingAddress = process.env.REACT_APP_LIQUIDITY_STAKING_ADDRESS || '';
    const secondLiquidityStakingAddress = process.env.REACT_APP_SECOND_LIQUIDITY_STAKING_ADDRESS || '';
    const activePoolIndex = Number(process.env.REACT_APP_ACTIVE_POOL_INDEX || 0);
    const lpTokenAddress = process.env.REACT_APP_LP_TOKEN_ADDRESS || '';
    const amasaTokenAddress = process.env.REACT_APP_TOKEN_ADDRESS || '';
    const rewardPerDay = process.env.REACT_APP_LIQUIDITY_REWARD_PER_DAY || '22222';

    const liquidityMiningContract = new Contract(
        stakingType === StakingType.FIRST ? liquidityStakingAddress : secondLiquidityStakingAddress,
        config.liquidityMiningABI,
        provider instanceof Web3Provider ? provider?.getSigner() : provider,
    );

    return {
        async getStakedBalanceLiq(
            accountAddress: string | null,
            makeupBalance: boolean,
        ) {
            let userInfo = await liquidityMiningContract.userInfo(activePoolIndex, accountAddress);
            const staked = formatEther(userInfo.amount.toString());
            if (!makeupBalance) {
                userInfo =
                    formatEther(userInfo.amount.toString());
            } else {
                userInfo = GeneralService().prettyTotalStaked(
                    formatEther(userInfo.amount.toString()).toString(),
                );
            }

            const data = {
                stakedBalance: staked,
                stakedBalancePretty: userInfo,
            };
            return data;
        },

        async checkApproval(accountAddress: string | null, tokenAddress: string) {
            let balance = await TokenService(provider).geBalance(accountAddress, tokenAddress);
            balance = formatEther(balance.toString());

            const allowance = await TokenService(provider).allowance(
                accountAddress,
                liquidityStakingAddress,
                tokenAddress
            );
            const ethAllowance = formatEther(allowance.toString());


            if (
                parseFloat(ethAllowance.toString()) >= parseFloat(balance.toString())
            ) {
                return true;
            } else {
                return false;
            }
        },
        async getLmDepositEnabled() {
            const depositEnabled = await liquidityMiningContract.depositEnabled();
            return depositEnabled;
        },

        async getPendingReward(
            accountAddress: string | null,
            makeup: boolean,
        ) {
            let makeupReward;
            let reward = await liquidityMiningContract.pendingReward(
                1,
                accountAddress,
            );
            if (!makeup) {
                makeupReward =
                    Math.floor(Number(formatEther(reward.toString())) * 10000000) /
                    10000000;
            } else {
                makeupReward = GeneralService().prettyTotalStaked(
                    formatEther(reward.toString()).toString(),
                );
            }

            const data = {
                pendingReward: reward,
                pendingRewardPretty: makeupReward,
            };

            return data;
        },
        async withdraw(amount: string) {
            return await liquidityMiningContract.withdraw(activePoolIndex, amount);
        },
        async claimReward() {
            return await liquidityMiningContract.claimReward(activePoolIndex);
        },
        async claimHarvest() {
            liquidityMiningContract.claimReward(activePoolIndex);
        },
        async withdrawClaim() {
            liquidityMiningContract.withdraw(activePoolIndex);
        },
        async deposit(amount: string) {
            return liquidityMiningContract.deposit(activePoolIndex, parseEther(amount));
        },

        async getStakingInfo() {
            const tokensInLP = await TokenService(provider).geBalance(lpTokenAddress, amasaTokenAddress);
            const allStakedLPTokens = Number(formatEther(tokensInLP)) * 2;
            const totalSupply = Number(formatEther(await TokenService(provider).getERC20TokenContract(lpTokenAddress).totalSupply()));
            const lpValueInAMASA = allStakedLPTokens / totalSupply;
            const stakedLpTokens = Number(formatEther(await TokenService(provider).geBalance(liquidityStakingAddress, lpTokenAddress)));
            const numberOfAmasaInStaking = stakedLpTokens * lpValueInAMASA;
            const tokenPerYear = 365 * Number(rewardPerDay);
            const price = await GeneralService().getAMASAPrice();
            return {
                apy: Math.round((tokenPerYear / numberOfAmasaInStaking) * 100),
                totalValueLocked: price === '-1' ? -1 : Math.round(numberOfAmasaInStaking * Number(price))
            };
        },
    }
}
